<!-- 全局查询 -->
<template>
    <div class="globalSearchbar">
        <el-input clearable
                  @input="inputHandler"
                  @clear="searchClear"
                   @focus="focusHandler"
                   :placeholder="selectedQueryTextTips" v-model="keyWord" class="input-with-select" @keyup.enter.native="searchEnterFun">
           <!--  <el-select  @change="querySelectChange($event)" v-model="selectedQueryValue" slot="prepend" placeholder="请选择">
                <el-option v-for="(item, index) in queryItems" :key="'queryItems'+index" :value="item.value" :label="item.label"></el-option>
            </el-select> -->
               <el-button slot="append" icon="iconfont icon-sousuo" @click="searchExcuteFun" v-if="!resultListViewShow"></el-button>
               <el-button slot="append" type="info" icon="iconfont icon-guanbi" @click="searchClear" v-if="resultListViewShow"></el-button>
        </el-input>
    </div>
</template>

<script>
import bus from '@/components/common/bus'
import { Notification } from 'element-ui'
import {mapResourceApi} from '@/api/mapResourceApi'
import {LAND_TYPE} from '@/views/class/mapmanager'
export default {
  data() {
    return {
      keyWord: '',
      selectedQueryTextTips: '请输入查询的内容',
      selectedQueryValue: 0,
      keywordFromMap: false,
      resultListViewShow: false,
      queryItems: [{
        value: LAND_TYPE.land_type_suoyou,
        label: '全部'
      }, {
        value: LAND_TYPE.land_type_gongye,
        label: '工业'
      }, {
        label: '商业',
        value: LAND_TYPE.land_type_shangye
      }, {
        label: '住宅',
        value: LAND_TYPE.land_type_zhuzhai
      }, {
        label: '其他',
        value: LAND_TYPE.land_type_qita
      }]
    }
  },
  watch: {
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    //
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // todo
    bus.$on('mapSelectedQueryValue', msg => {
      // this.selectedQueryValue = msg
    })
    bus.$on('mapClick', msg => {
      this.keywordFromMap = true
    })
    bus.$on('searchClear', msg => {
      this.keyWord = ''
    })
  },
  methods: {
    /**
       * 查询框的下拉选事件
       */
    querySelectChange(val) {
      this.selectedQueryValue = val
      if (this.resultListViewShow) {
        const keyWord = this.keyWord
        this.querySelectLand(keyWord)
      }
    },
    querySelectLand(keyWord) {
      const status = '2'
      const params = {
        status
      }
      mapResourceApi.getLandInfoList(params).then(response => {
        if (response.code === '200') {
          const featuresObj = JSON.parse(response.data)
          bus.$emit('initListData', featuresObj.features)
          this.$parent.$refs.mapsearchresults.initResultList(keyWord, this.selectedQueryValue)
        } else {
          Notification.warning({
            title: '警告',
            message: '加载图层数据出错!',
            type: 'warning'
          })
        }
      })
    },
    searchEnterFun(e) {
      const keyCode = window.event ? e.keyCode : e.which
      if (keyCode === 13) {
        const keyWord = this.keyWord
        /* if (keyWord === '') {
          this.$message.warning('请输入搜索条件！')
          return
        } */
        this.getQueryWhereParam(keyWord)
      }
    },
    searchExcuteFun(e) {
      const keyWord = this.keyWord
      /*  if (keyWord === '') {
        this.$message.warning('请输入搜索条件！')
        return
      } */
      this.getQueryWhereParam(keyWord)
    },
    getQueryWhereParam(queryWord) {
      if (this.keywordFromMap) {
        return
      }
      if (queryWord === '' && this.$parent.resultViewShow === true) {
        return
      }
      this.$parent.resultViewShow = true
      this.resultListViewShow = true
      this.querySelectLand(queryWord)
    },
    searchClear() {
      console.log('清空')
      this.$parent.resultViewShow = false
      this.keyWord = ''
      this.keywordFromMap = false
      this.resultListViewShow = false
      bus.$emit('searchClear')
    },
    focusHandler() {
      const keyWord = this.keyWord
      // this.getQueryWhereParam(keyWord)
    },
    inputHandler(value) {
      if (this.keywordFromMap === false && value === '') {
        this.searchClear()
      } else {
        if (this.resultListViewShow === true) {
          this.resultListViewShow = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .globalSearchbar {
        position: absolute;
        left: 40px;
        top: 15px;
        z-index: 490;
        width: 80%;
        ::v-deep{
            .el-select {
                .el-input {
                    width: 80px;
                }
            }
            .el-input-group__append {
                width: 53px;
                background: #2b74e5;
                border: 1px solid rgba(0, 0, 0, 0);
                opacity: 1;
                border-radius: 0px 4px 4px 0px;
                color: #fff;
            }
            .el-input-group__prepend {
                border-right: 0;
                background: #fff;
                color: #333333;
            }
        }
    }
</style>
